
import { useContext } from 'react';
import { baseUrl_SPB } from '../BaseUrl';
 const FetchUnavailabilities = async (token,id) => {

         
      try {
        const response = await fetch(`${baseUrl_SPB}/api/v1/unavailability/getall?staffId=`+id, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        
        if (!response.ok) {
          throw new Error('Failed to unavailability data');
        }

        const data = await response.json();
        return data;
        
      } catch (error) {
        console.error('Error fetching unavailability:', error);
      }
    }



    export default FetchUnavailabilities;